var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellIconPlain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 36,
    viewBox: "0 0 34 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7681 32.4C19.4868 32.8849 19.083 33.2874 18.5973 33.5672C18.1115 33.8471 17.5607 33.9943 17.0001 33.9943C16.4395 33.9943 15.8887 33.8471 15.4029 33.5672C14.9172 33.2874 14.5134 32.8849 14.2321 32.4M26.6001 11.6C26.6001 9.05392 25.5887 6.61212 23.7883 4.81177C21.988 3.01143 19.5462 2 17.0001 2C14.454 2 12.0122 3.01143 10.2119 4.81177C8.41152 6.61212 7.4001 9.05392 7.4001 11.6C7.4001 22.8 2.6001 26 2.6001 26H31.4001C31.4001 26 26.6001 22.8 26.6001 11.6Z",
    stroke: "#F7F7F7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIconPlain);
export default __webpack_public_path__ + "static/media/Bell-Icon-Plain.2c80654eb4e9afb42b7ef02641d6fc48.svg";
export { ForwardRef as ReactComponent };